export const routes = [
  {
    path: "/p/:rota",
    name: "paginaDinamica",
    component: () =>
      import(
        /* webpackChunkName: "view-pagina-dinamica" */ "./components/Main.vue"
      ).catch(() => {
        location.reload();
      }),
  },
];
